import { LOAD_TOP_TRACKS, UNLOAD_CURRENT_ARTIST } from '../actionTypes';
import { loadReducer } from './helpers';

export const topTracks = (state = null, action) => {
  switch (action.type) {
    case UNLOAD_CURRENT_ARTIST:
      return null;
    case LOAD_TOP_TRACKS:
      return loadReducer(state, action);
    default:
      return state;
  }
};
